const WithProp = (Component, propName, propValue) => {
    Component[propName] = propValue;
    return Component;
}

export const WithType = (Component, type) => WithProp(Component, "type", type);

export const WithInfo = (Component, type) => WithProp(Component, "info", type);

